import React from "react";
import { useState, useEffect } from "react";
function NavigateURL() {
  useEffect(() => {
    // RedirectMe();
  }, []);

  // function RedirectMe() {
  //   window.location =
  //     "https://www.pfibusinesstools.com/SSO.aspx?GetMeLogIn=https://repscorecardapp.pfibusinesstools.com/verifycr?a=1" as any;
  // }

  return <div></div>;
}

export default NavigateURL;
